/*
 * @Author: mayanxia 
 * @Date: 2022-01-11 11:25:53 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-13 14:09:37
 */

<template>
    
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :okButtonProps="{ props: {disabled: disableSubmit} }"
      :maskClosable="maskClosable"
      @ok="handleOk"
      @cancel="handleCancel"
      :cancelText="$t('关闭')">
        <a-spin :spinning="confirmLoading">
        <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
            <a-row :gutter="48">
              <a-col :span="12">
                    <a-form-model-item :label="$t('规则名称')"  prop="warnName" has-feedback>
                    <a-input :disabled="disableSubmit||isUsed" v-model.trim="model.warnName" :placeholder="$t('请输入规则名称')"  ></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('价格名称')"  prop="priceId">
                        <a-select :disabled="disableSubmit||isUsed" v-model.trim="model.priceId" :placeholder="$t('请选择用户价格名称')">
                            <a-select-option v-for="data in priceList" :key="data.id" :value="data.id">
                            {{data.wtName}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('表口径')"  prop="mtCaliber">
                        <a-select :disabled="disableSubmit||isUsed" v-model="model.mtCaliber" :placeholder="$t('表口径')">
                            <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                              DN{{data.mtCaliber}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('规则类型')" prop="compareType">
                        <j-dict-select-tag v-model="model.compareType" :placeholder="$t('请选择规则类型')" dictCode="compare_type" :disabled="disableSubmit||isUsed" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('比较值(日用量:m³)')" prop="compareValue">
                        <a-input-number :disabled="disableSubmit||isUsed" style="width: 100%" v-model="model.compareValue" :placeholder="$t('请输入比较值')" :precision="2" :min="0"></a-input-number>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('是否启用')" prop="warnState">
                        <a-switch :disabled="disableSubmit" v-model="model.warnState" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item :label="$t('备注')"  prop="remark">
                        <a-textarea :disabled="disableSubmit" v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
</template>
<script>

  import { httpAction, getAction } from '@/api/manage'
  import { listSize } from '@/utils/util'
  import { mapGetters } from 'vuex'
  import {isUndefined} from'@/utils/validate'

  export default {
    name: 'MeterUseWarnConfigModal',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
          warnName:undefined,
          priceId: undefined,
          compareType: undefined,
          compareValue: undefined,
          warnState: false,
          mtCaliber: undefined,

        },
        maskClosable:false,
        title: this.$t("操作"),
        visible: false,
        disableSubmit:false,
        confirmLoading: false,
        isUsed: false,
        url: {
          add: "/jeecg-charge/meter/meterUseWarnConfig/add",
          edit: "/jeecg-charge/meter/meterUseWarnConfig/edit",
          queryUserCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址,
          queryPrice: "/jeecg-charge/meter/meterPriceinfo/list",
          warnConfigList: "/jeecg-charge/meter/meterUseWarnConfig/list",
        },
        userCaliberList: [],
        priceList: []
      }
    },
    created () {
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      rules() {
        return {
          warnName:[
            { required: true, message: this.$t('请输入规则名称')},
            {
                validator: this.validateWarnName
              }
            ],
          priceId:[{ required: true, message: this.$t('请选择价格名称')}],
          mtCaliber:[{ required: true, message: this.$t('请选择表口径')}],
          compareType:[{ required: true, message: this.$t('请选择规则类型')}],
          compareValue:[{ required: true, message: this.$t('请输入比较值')}],
        }
      },
    },
    methods: {
        ...mapGetters(["userInfo"]),
      add () {
          console.log("添加")
        this.edit(this.model);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        console.log(this.model)
        if(this.model.warnState === 1) {
          this.model.warnState = true
        }
        this.queryPriceList();
        this.queryUserCaliberList();
        this.visible = true;
      },
      handleOk () {
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if(valid) {
            this.confirmLoading = true;
            let params = {...this.model}
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            if(this.model.warnState) {
              params.warnState = 1
            }else{
              params.warnState = 0
            }
            const that = this;
            // 如果是启用状态需要增加判断判断当前价格、当前口径启用的告警配置是否大于5条，5条就不能启用新的告警配置了
            if(params.warnState == 1) {
              this.queryStartWarnConfigByPriceIdAndmtCaliber().then((res) => {
                if(res==null||res<5) {
                  httpAction(httpurl,params,method).then((res)=>{
                    if(res.success){
                      that.$message.success(res.message);
                      that.$emit('ok');
                      that.close()
                    }else{
                      that.$message.warning(res.message);
                    }
                  }).finally(() => {
                    that.confirmLoading = false;
                  })
                }else{
                  that.confirmLoading = false;
                  that.$message.error(that.$t("该价格和口径告警配置启用数不能大于5"))
                }
              }).catch(error => {
                this.$message.error(error)
                that.confirmLoading = false;
              })
            }else{
              httpAction(httpurl,params,method).then((res)=>{
                if(res.success){
                  that.$message.success(res.message);
                  that.$emit('ok');
                  that.close()
                }else{
                  that.$message.warning(res.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
              })
            }
          }
        })
      },
      close () {
        this.$emit('close');
        console.log("l")
        this.model = this.$options.data.call(this).model;
        this.$refs.formModal.resetFields()
        console.log(this.model)
        console.log("2")
        this.disableSubmit = false;
        console.log("3")
        this.isUsed = false;
        this.visible = false;
      },
      // 查询当前价格、口径的启用配置告警数
      queryStartWarnConfigByPriceIdAndmtCaliber() {
        let params = {warnState: 1,pageNo: 1,pageSize: 10}
        params.mtCaliber = this.model.mtCaliber
        params.priceId = this.model.priceId
        return new Promise((resolve, reject) => {
          getAction(this.url.warnConfigList, params).then((res) => {
            if(res.success){
              resolve(res.result.total)
            }else{
              reject(res.message)
            }
          }).catch(error => {
            reject(error)
          })
        })
      },
      handleCancel () {
        this.close();
      },
      queryPriceList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.queryPrice, params).then((res) => {
          if(res.success){
            this.priceList = res.result.records;
          }
        }) 
      },
      queryUserCaliberList() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.queryUserCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
          }
        }) 
      },

      validateWarnName(rule, value, callback){
        if(isUndefined(value)||value === '') {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let params = {warnName: value,sysOrgCode: org}
        getAction(this.url.warnConfigList,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该规则名称已存在!"))
            }
          } else {
            callback()
          }
        })
      }
    }
  }
</script>